import { dashboardSsoApi, dashboardApi } from './http';
import { getAuthInLocalStorage } from '../utils/localStorage';

export async function getGroups() {
  const { token } = getAuthInLocalStorage();
  dashboardSsoApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await dashboardSsoApi.get('/basicuser/v1/groups');
  return response.data;
}

export async function getPurposesPages() {
  const { token } = getAuthInLocalStorage();
  dashboardApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await dashboardApi.get('/dashboard/v1/app/full');
  return response.data;
}
